import { useRoute } from "vue-router"

export default {
	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	computed: {
		isAdminPortal() { return useRoute().fullPath.startsWith("/admin/") },
		isApprovalPortal() { return useRoute().fullPath.startsWith("/submission") },
		isReportPortal() { return useRoute().fullPath.startsWith("/reporting/") },
		isAuditLogPortal() { return useRoute().fullPath.startsWith("/audit/") },
		isEmployeePortal() { return !useRoute().fullPath.startsWith("/admin/") && !useRoute().fullPath.startsWith("/submission") && !useRoute().fullPath.startsWith("/audit/") || useRoute().fullPath.startsWith("/reporting/")}
	},
};